import { useState } from 'react';
import { toast } from 'react-toastify';
import { authApi } from '../api-client/auth';
import { ErrorMessages } from '../interfaces/Auth.interface';

export const useAuth = () => {
  const [errors, setErrors] = useState<ErrorMessages | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const verifyUser = async (email: string) => {
    setLoading(true);
    try {
      const response = await authApi.verifyUser(email);
      return response.data;
    } catch (error: any) {
      toast.error('Oops, something went wrong!');
      if (error.response?.data?.details) {
        setErrors(error.response.data.details);
      } else if (error.response?.data?.message) {
        setErrors({ email: [error.response.data.message] });
      } else {
        setErrors({ email: ['An unknown error occurred'] });
      }
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    errors,
    verifyUser
  };
};
